<template>
  <div>
    <div v-if="$slots.controls" class="mb-[14px]">
      <slot name="controls" />
    </div>
    <div>
      <slot name="filters" />
    </div>
    <div class="mt-[32px]">
      <slot name="table" />
    </div>
  </div>
</template>
